import Vue from 'vue';
import Router from 'vue-router';

import { routes } from './routes';

Vue.use(Router);

const router = new Router({
  base: process.env.VUE_APP_BASEPATH,
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { selector: to.hash, behavior: 'smooth' };
    return { x: 0, y: 0 };
  },
});

router.afterEach(to => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle ? `Portal | ${to.meta.pageTitle}` : 'Portal';
  });
});

router.onError(error => {
  if (/Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/.test(error.message)) {
    window.location.reload();
  }
});

export { router };
